import { State, Action, StateContext, Selector } from '@ngxs/store';
import { DialogStateModel } from './dialog.state.model';
import { DialogActions } from './dialog.actions';
import { DialogService } from '../dialog.service';
import { Injectable } from '@angular/core';

@State<DialogStateModel>({
  name: 'dialog',
  defaults: {
    openDialog: null,
  },
})
@Injectable()
export class DialogState {
  /**
   * Selectors
   */
  @Selector()
  static getOpenDialog(state: DialogStateModel) {
    return state.openDialog;
  }

  /**
   * Actions
   */

  // Limit
  @Action(DialogActions.OpenLimit)
  openLimit(context: StateContext<DialogStateModel>, action: DialogActions.OpenLimit) {
    const dialogRef = this.dialogService.openLimitDialog();
    dialogRef.afterClosed().subscribe((upgrade) => {
      context.dispatch(new DialogActions.CloseLimit(upgrade));
    });
  }

  @Action(DialogActions.CloseLimit)
  closeLimit(context: StateContext<DialogStateModel>, action: DialogActions.CloseLimit) {
    if (action.upgrade) {
      this.dialogService.openUpgradeDialog();
    }
  }

  // Premium Content
  @Action(DialogActions.OpenPremiumContent)
  openPremiumContent(
    context: StateContext<DialogStateModel>,
    action: DialogActions.OpenPremiumContent,
  ) {
    const dialogRef = this.dialogService.openPremiumContentDialog();
    dialogRef.afterClosed().subscribe((confirmed) => {
      context.dispatch(new DialogActions.ClosePremiumContent(confirmed));
    });
  }

  @Action(DialogActions.ClosePremiumContent)
  closePremiumContent(
    context: StateContext<DialogStateModel>,
    action: DialogActions.ClosePremiumContent,
  ) {
    if (action.confirmed) {
      context.dispatch(new DialogActions.OpenUpgrade());
    }
  }

  // Upgrade
  @Action(DialogActions.OpenUpgrade)
  openUpgrade(context: StateContext<DialogStateModel>, action: DialogActions.OpenUpgrade) {
    this.dialogService.openUpgradeDialog();
  }

  constructor(private dialogService: DialogService) {}
}
